export default __webpack_public_path__ + "images/VL.2e82b17.png";